(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/events/pubsub.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/events/pubsub.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  svs.components.dialog.PubSub = function () {
    function PubSub() {
      _classCallCheck(this, PubSub);

      this.callbacks = {};
    }

    _createClass(PubSub, [{
      key: "emit",
      value: function emit(event, data) {
        if (this.callbacks[event]) {
          this.callbacks[event].forEach(function (callback) {
            callback.callback.call(callback.context, data);
          });
        }
      }
    }, {
      key: "on",
      value: function on(event, context, callback) {
        if (!this.callbacks[event]) {
          this.callbacks[event] = [];
        }

        this.callbacks[event].push({
          context: context,
          callback: callback
        });
      }
    }, {
      key: "off",
      value: function off(event, context) {
        if (this.callbacks[event]) {
          for (var i = 0; i < this.callbacks[event].length; i++) {
            var item = this.callbacks[event][i];

            if (item.context === context) {
              this.callbacks[event].splice(i, 1);
              break;
            }
          }
        }
      }
    }]);

    return PubSub;
  }();
})(svs);
 })(window);